import { useState } from "react";
import { Link } from "react-router-dom";
import type { FaqItem } from "@/types/content";

export default function FaqPreview({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section aria-labelledby="faq-preview-title" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-question-line"></i>
              </span>
              常见问题
            </span>
            <h2
              id="faq-preview-title"
              className="mt-3 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-[40px]"
            >
              关于吃瓜
              <br />
              你可能想知道
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              内容从哪里来、怎么筛选学校、发言要注意什么，这里都有说明。如果还有其他疑问，欢迎直接联系我们。
            </p>
            <Link
              to="/faq"
              className="mt-7 inline-flex items-center gap-2 rounded-md border border-foreground-300 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 whitespace-nowrap"
            >
              查看全部问题
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          <div className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {items.map((item, index) => {
              const open = openIndex === index;
              return (
                <div key={item.question}>
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? -1 : index)}
                      aria-expanded={open}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                    >
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-[15px]">
                        {item.question}
                      </span>
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                          open ? "bg-primary-500 text-background-50 dark:text-foreground-950" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                  </h3>
                  {open && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                      {item.answer}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}